<template>
<section><slot /></section>
</template>

<script>
import html2canvas from 'html2canvas'

export default {
  name: 'ScreenShot',
  methods: {
    getScreenShot () {
      let el = this.$el
      return html2canvas(el, {
        logging: true,
        allowTaint: true,
        useCORS: true
      }).then(canvas => new Promise(resolve => {
        let tmpCanvas = document.createElement('canvas')
        let width = el.offsetWidth
        let height = el.offsetHeight
        let tmpCtx = tmpCanvas.getContext('2d')

        tmpCanvas.width = width
        tmpCanvas.height = height

        tmpCtx.drawImage(
          canvas,
          0, 0,
          canvas.width, canvas.height,
          0, 0,
          width, height
        )

        resolve(tmpCanvas.toDataURL('image/jpg'))
      }))
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ScreenShot/index.vue